// Single source of truth for the Start Procedure asset-identifier fields —
// per docs/asset_management/ROB-293_asset_management_api_contract.md, the
// backend has no schema-serving endpoint, so the UI hardcodes this and reuses
// it for the popup, the Logbook list columns, and the Logbook detail cards.
export const ASSET_IDENTIFIER_FIELDS_BY_CATEGORY = {
  Aviation: [
    { key: "tail_number", label: "Tail Number", required: true },
    { key: "air_frame", label: "Air Frame", required: true },
  ],
  Automotive: [{ key: "vin", label: "VIN", required: true }],
  Maritime: [
    { key: "hull_number", label: "Hull Number", required: false },
    { key: "assembly", label: "Assembly", required: false },
    { key: "sub_assembly", label: "Sub-assembly", required: false },
  ],
  Other: [{ key: "serial_number", label: "Serial Number", required: true }],
};

export const getAssetIdentifierFields = category =>
  ASSET_IDENTIFIER_FIELDS_BY_CATEGORY[category] ??
  ASSET_IDENTIFIER_FIELDS_BY_CATEGORY.Other;

export const ASSET_IDENTIFIER_LABELS = Object.fromEntries(
  Object.values(ASSET_IDENTIFIER_FIELDS_BY_CATEGORY)
    .flat()
    .map(field => [field.key, field.label]),
);

// Same subheader for every category, per PM (confirmed against the Figma
// popup mockup) — overrides the ticket's original per-category copy.
export const ASSET_IDENTIFIER_SUBHEADER =
  "Enter the following information to begin. This will be recorded in the maintenance log.";
